import { MongoObservable } from "meteor-rxjs";
import { Meteor } from "meteor/meteor";
import { User } from "../models";
import { Pictures } from "./pictures";

export const Users = new MongoObservable.Collection<User>("users", { connection: null });


// Dispose unused profile pictures
Meteor.users.after.update(function(userId, doc, fieldNames, modifier, options) {
  if (!doc.profile) { return; }
  if (!this.previous.profile) { return; }
  if (doc.profile.pictureId == this.previous.profile.pictureId) { return; }

  Pictures.collection.remove({ _id: this.previous.profile.pictureId });
}, { fetchPrevious: true });

Meteor.startup(() => {
  if (Meteor.isServer) {
    Meteor.users._ensureIndex({companyIds: 1});
    Meteor.users._ensureIndex({profile: 1});
    Meteor.users._ensureIndex({emails: 1});
  }
});



// WEBPACK FOOTER //
// ./src/api/server/collections/users.ts